/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AccountService } from '../../services/account.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../services/user.service';
import { ErrorService } from '../../services/error.service';

@Component({
  selector: 'reset-password',
  templateUrl: './reset-password.component.html',
  standalone: false,
})
export class ResetPasswordComponent {
  @Input() resetObj: ResetObject;
  confirmPassword: string;
  error: string;

  constructor(
    private accountService: AccountService,
    private userService: UserService,
    public activeModal: NgbActiveModal,
    private errorService: ErrorService,
  ) {}

  async resetPassword(f: NgForm) {
    this.error = '';
    try {
      await this.accountService.resetPassword(this.resetObj);
      this.userService.login(this.resetObj.email, this.resetObj.newPassword);
      this.activeModal.close();
    } catch (error) {
      try {
        f.form.get('newPassword')?.setErrors({ invalid: true });
      } catch (error) {
        this.errorService.displayGeneralError().result.then(() => {
          this.activeModal.dismiss();
        });
      }
    }
  }
}

export interface ResetObject {
  token: string;
  email: string;
  resetType: string;
  newPassword: string;
}
